import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading @message="Loading streamer profile..." @subtitle="Getting streamer details, schedule, and content" />
</template>
